import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';

/* MODAL */
import { useModal } from 'hooks/modalContext';
import CloseBtn from 'components/util/CloseModal';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

const DispatchModal = props => {
  const { closeModal } = useModal();

  const [item, setItem] = useState({
    workerId: '',
    serialNumber: '',
    workerName: '',
    workerPhone: '',
    phone: '',
  });
  const [isData, setIsData] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isIdCheck, setIsIdCheck] = useState(false);
  const [isPhoneCheck, setIsPhoneCheck] = useState(!props.props?.isRegi);

  useEffect(() => {
    if (!props.props?.isRegi && !isData) {
      setItem(props.props?.data.item);
      setIsData(true);
    }
  }, [props]);

  const validation = () => {
    const workerMsgArr = [
      'ID required.',
      'Name required.',
      'Phone required.',
    ];
    const workerColumn = [
      'workerId',
      'workerName',
      'workerPhone',
    ];

    for (let i = 0; i < workerColumn.length; i++) {
      if (Common.isEmpty(item[workerColumn[i]])) {
        Common.errorMsg(workerMsgArr[i]);

        return false;
      }
    }

    if (props.props?.isRegi && !isIdCheck) {
      Common.errorMsg('ID verification required.');

      return false;
    }

    if (!isPhoneCheck) {
      Common.errorMsg('Phone verification required.');

      return false;
    }

    return true;
  };

  const setWorker = () => {
    if (validation() && !isSubmit) {
      confirmAlert({
        title: 'Are you sure you want to save?',
        buttons: [{
          label: 'Yes',
          onClick: () => {
            setIsSubmit(true);

            const request = props.props?.isRegi ? Server.sendPost : Server.sendPut;

            request('workforce/worker', item, setWorkerCallback).then();
          }
        }, {
          label: 'No'
        }]
      });
    }
  };

  const setWorkerCallback = () => {
    setIsSubmit(false);

    props.props.data.callback();

    Common.alertSuccess();

    closeModal();
  };

  const workerIdCheck = () => {
    if (isIdCheck) return;

    if (Common.isEmpty(item.workerId)) {
      Common.errorMsg('ID required.');

      return;
    }

    Server.sendGet('workforce/worker/id', {
      workerId: item?.workerId
    }, workerIdCheckCallback).then();
  };

  const workerIdCheckCallback = res => {
    if (res?.['resultCount'] === 0) {
      setIsIdCheck(true);

      Common.errorMsg('Available.');
    } else {
      Common.errorMsg('ID existing.');

      setItem(() => {
        return {
          ...item,
          workerId: '',
        }
      });
    }
  };

  const workerPhoneCheck = () => {
    if (isPhoneCheck) return;

    if (Common.isEmpty(item.workerPhone)) {
      Common.errorMsg('Phone required.');

      return;
    }

    Server.sendGet('workforce/worker/phone', {
      workerPhone: item?.workerPhone
    }, workerPhoneCheckCallback).then();
  };

  const workerPhoneCheckCallback = res => {
    if (res?.['resultCount'] === 0) {
      Common.errorMsg('Available.');

      setIsPhoneCheck(true);
    } else {
      Common.errorMsg('Phone existing.');

      setItem(() => {
        return {
          ...item,
          workerPhone: '',
        }
      });
    }
  };

  return (
    <>
      <CloseBtn onClick={closeModal}/>
      
      <div className='modal-box'>
        <div className='inner'>
          <Title>
            <TitHead>
              <i/>
              <h4>Dispatch workforce {props.props?.isRegi ? 'Registration' : 'Modify'}</h4>
            </TitHead>
          </Title>
          <ModalForm>
            <FormIn>
              <FormInWrap>
                <label><span>* </span>ID</label>
                <FormInput
                  style={{ width: props.props?.isRegi ? 'calc(55% - 20px)' : 'calc(70% - 10px)' }}
                  type='text'
                  id='workerId'
                  name='workerId'
                  value={item?.workerId}
                  readOnly={!props.props?.isRegi}
                  onChange={e => {
                    setItem(() => {
                      return {
                        ...item,
                        workerId: e.target.value,
                      }
                    });
                    setIsIdCheck(false);
                  }}
                />
                {props.props?.isRegi &&
                  <Btn
                    style={{
                      flex: 'none',
                      width: '15%',
                      fontSize: '16px',
                      background: !isIdCheck ? '#0072b9' : '#a4a4a4'
                    }}
                    onClick={workerIdCheck}
                  >Check</Btn>
                }
              </FormInWrap>
              <FormInWrap>
                <label><span>* </span>Name</label>
                <FormInput
                  type='text'
                  id='workerName'
                  name='workerName'
                  value={item?.workerName}
                  onChange={e => {
                    setItem(() => {
                      return {
                        ...item,
                        workerName: e.target.value,
                      }
                    })
                  }}
                />
              </FormInWrap>
            </FormIn>
            <FormIn>
              <FormInWrap style={{ width: '100%'}}>
                <label style={{ width: '75px'}}><span>* </span>Phone</label>
                <FormInput
                  style={{ flex:'1' }}
                  type='text'
                  id='workerPhone'
                  name='workerPhone'
                  value={item?.workerPhone}
                  onChange={e => {
                    e.target.value = Common.onlyNumber(e.target.value);

                    if (e.target.value !== item.phone) {
                      setIsPhoneCheck(false);
                    } else {
                      setIsPhoneCheck(true);
                    }

                    setItem(() => {
                      return {
                        ...item,
                        workerPhone: e.target.value,
                      }
                    });
                  }}
                />
                <Btn
                  style={{
                    flex: 'none',
                    width: '100px',
                    fontSize: '16px',
                    background: !isPhoneCheck ? '#0072b9' : '#a4a4a4'
                  }}
                  onClick={workerPhoneCheck}
                >Check</Btn>
              </FormInWrap>
            </FormIn>
            <FormBtn $Btn>
              <Btn onClick={closeModal}>Cancel</Btn>
              <Btn $Color onClick={setWorker}>Submit</Btn>
            </FormBtn>
          </ModalForm>
        </div>
      </div>
    </>
  );
}

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
  }
`;

const ModalForm = styled.div`
  margin-top: 20px;
  position: relative;
  border-top: 1px solid #eeeeee;

  & > div + div {
    margin-top: 10px;
  }
`;

const FormIn = styled.div`
  display: flex;
  gap: 10px 20px;

  & select {
    width: calc(70% - 10px);
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
    border: 1px solid #cccccc;
    border-radius: 5px;
    outline: none;
    font-weight: 400;
    font-size: 16px;
    color: #000000;

    &:focus {
      border-color: #0072B9;
    }
  }

  & textarea {
    width: calc(70% - 10px);
    height: 150px;
    padding: 10px 16px;
    background: #f8f8f8;
    border-radius: 5px;
    border: 1px solid #cccccc;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    resize: none;
    outline: none;

    &:focus {
      border-color: #0072B9;
    }
  }
`;

const FormInWrap = styled.div`
  display: inline-flex;
  width: 50%;
  align-items: center;
  gap: 0 10px;
  float: left;
  height: 60px;

  & label {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    width: 30%;

    & span {
      font-size: 11px;
      color: red;
    }
  }
`;

const FormInput = styled.input`
  width: calc(70% - 10px);
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  background: #f8f8f8;
  border: 1px solid #cccccc;
  border-radius: 5px;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  outline: none;

  &:focus {
    border-color: #0072B9;
  }
`;

const FormBtn = styled.div`
  margin-top: 25px !important;
  display: flex;
  align-items: center;
  gap: 0 8px;
`;

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

export default DispatchModal;